module.exports = __webpack_public_path__ + "static/media/2DGACM15.ab536ce3.jpg";